export default {"src":"/_next/static/media/HumanoidImage.8bc016b7.svg","height":573,"width":1218,"blurWidth":0,"blurHeight":0};